import { useAppSelector } from "../hooks";
import { useEffect, useState } from "react";
import {
  addToFavorite,
  clearFollowedItems,
  getFavorite,
  removeFromFavorite,
  useAppDispatch,
} from "@lib/stores";
import { Server } from "@wajeez/wajeez.microservices";
import { getFavoriteContentEntitiyByIdAsync } from "@lib/stores/myLibrary/slices";

export const useGetStarted = () => {
  const { data, meta, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.started
  );

  return {
    data,
    meta,
    status,
  };
};

export const useGetCompleted = () => {
  const { data, meta, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.completed
  );

  return {
    data,
    meta,
    status,
  };
};

export const useGetFavorite = () => {
  const { data, meta, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.favorite
  );

  return {
    data,
    meta,
    status,
  };
};

export const useGetBookmarked = () => {
  const { data, meta, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.bookmarked
  );

  return {
    data,
    meta,
    status,
  };
};

export const useGetHighlighted = () => {
  const { data, meta, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.highlighted
  );

  return {
    data,
    meta,
    status,
  };
};

export const useGetBookmarkedDetails = () => {
  const { data, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.bookmarkedDetails
  );

  return {
    data,
    status,
  };
};

export const useGetHighlightedDetails = () => {
  const { data, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.highlightedDetails
  );

  return {
    data,
    status,
  };
};

export const useGetMyPlaylists = () => {
  const { data, meta, status } = useAppSelector(
    ({ myLibrary }) => myLibrary.paginatedplaylists
  );

  return {
    data,
    meta,
    status,
  };
};

export const useFavorite = (
  content:
    | Server.ContentEntityOutput
    | (Server.ContentEntityOutput & {
        isLocked: boolean | undefined;
      })
    | undefined
    | null
) => {
  const dispatch = useAppDispatch();
  const favContents = useAppSelector(
    (state) => state.myLibrary.favoriteContentEntitiy.data
  );

  const isFavContentEntity =
    content?.id && favContents?.includes(content?.id) ? true : false;
  const [isFavorite, setIsFavorite] = useState<boolean>(isFavContentEntity);

  useEffect(() => {
    if (content?.id) {
      dispatch(getFavoriteContentEntitiyByIdAsync([content?.id]));
    }
  }, [dispatch, content?.id]);

  useEffect(() => {
    setIsFavorite(isFavContentEntity);
  }, [isFavContentEntity]);

  const handleFavoriteClick = () => {
    if (!content?.id) return;

    const input = {
      contentEntityId: content.id,
    };

    const wasFavorite = isFavorite;

    setIsFavorite(!wasFavorite);

    try {
      if (wasFavorite) {
        removeFromFavorite(input, () => {
          clearFollowedItems();
          getFavorite({
            PageNumber: 1,
            PageSize: 5,
            SortBy: Server.SortBy.MostRecent,
          });
        });
      } else {
        addToFavorite(input, () => {
          clearFollowedItems();
          getFavorite({
            PageNumber: 1,
            PageSize: 5,
            SortBy: Server.SortBy.MostRecent,
          });
        });
      }
    } catch (error) {
      setIsFavorite(wasFavorite);
      console.error("Failed to update favorite:", error);
    }
  };

  return {
    isFavorite,
    handleFavoriteClick,
  };
};
